module.exports = __webpack_public_path__ + "static/media/slider1_mob.3c68c833.png";